import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-navbar gfu-navbar--lighter gfu-navbar--elevate _jc-c" }
const _hoisted_2 = { class: "gfu-navbar-nav gfu-navbar-nav--scrollable gfu-navbar-nav--secondary" }
const _hoisted_3 = { class: "gfu-navbar-nav__wrapper" }
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.navigationItems, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.pageName,
            ref_for: true,
            ref: item.ref,
            class: _normalizeClass(item.classes),
            "data-qa": `slider-navigation:${item.pageName}`
          }, [
            _createElementVNode("a", {
              href: item.url,
              class: "gfu-navbar-link"
            }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_5)
          ], 10 /* CLASS, PROPS */, _hoisted_4))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}